import { TaskFilter } from '../interfaces';
import { useGetTasksQuery } from '../services/tasks.service';

interface UseTasksProps {
  filter: TaskFilter;
  paginated: {
    page: number;
    pageSize: number;
  };
}

const useTasks = ({ filter, paginated }: UseTasksProps) => {
  const {
    data,
    isLoading,
    isFetching,
    isError,
  } = useGetTasksQuery({
    filter,
    paginated,
  });

  const totalItems = data?.count ?? 0;
  const pageSize = paginated.pageSize > 0 ? paginated.pageSize : 1;

  return {
    tasks: data?.items ?? [],
    totalItems,
    totalPages: Math.ceil(totalItems / pageSize),
    isLoading,
    isFetching,
    isError,
  };
};

export default useTasks;
